/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { Route, Switch, Redirect, useLocation } from "react-router-dom";
import Utils from "Utils/utils";
import TemplateComponennt from "Pages/Dashboard/templates/TemplateModule";
import ContactsComponent from "Pages/Dashboard/contacts/main";
import TaskRouting from "Routes/TaskRouting";
import SettingsComponent from "Pages/Dashboard/settings/Settings";
import SequencesRouting from "Routes/SequencesRouting";
import AgentsRouting from "Pages/Dashboard/agents/AgentsRouting";
import SignalsPage from "Pages/Dashboard/signals/SignalsPage";
import SignalTrackerPage from "Pages/Dashboard/signals/tracker/SignalTrackerPage";
import CompetitorsPage from "Pages/Dashboard/signals/CompetitorsPage";
import { withSignals } from "Pages/Dashboard/signals/signalsGate";
import { userDetail } from "Stores/userDetail";
import PricingModule from "Pages/Dashboard/pricing/PricingModule";
import ReportsModule from "Pages/Dashboard/reports/ReportsModule";
import ReportsModulev2 from "Pages/Dashboard/reports_v2/main";
import PluginSuccess from "Pages/Dashboard/Plugin/PluginSuccess";
import OutboxComponent from "Pages/Dashboard/outbox/main";
import CallsModule from "Pages/Dashboard/Calls/CallsModule";
import DashboardModule from "Pages/Dashboard/dashboard/main";
import DiscoverV2Module from "Pages/Dashboard/dataSearchV2/index";
import WebsiteTrackingModule from "Pages/Tracking/main";
import Accounts from "Pages/Dashboard/Accounts/Main";
import DeepResearch from "Pages/Dashboard/DeepResearch/DeepResearch";
import Copilot from "Pages/Dashboard/Copilot/Copilot";
import VisualFixtures from "Pages/Dashboard/Copilot/components/visuals/VisualFixtures";
import DataToolkitModule from "Pages/Dashboard/data-toolkit/main";

// Signals is a team flag: a direct link with it off shows the off state, not the page.
const SignalTrackerRoute = withSignals(SignalTrackerPage);
const CompetitorsRoute = withSignals(CompetitorsPage);
const SignalsRoute = withSignals(SignalsPage);

export const DashboardRouting = observer(() => {
  const {
    subscriptionPlanId,
    newReportsEnabled = false,
  } = userDetail?.userFeatureFlag || {};
  const { team } = userDetail?.userInfo || {};
  const [adminTeamUser, setAdminTeamUser] = useState(team);

  let location = useLocation();
  let queryParams = Utils.getQueryParams(location.search);
  let pluginUser = queryParams?.get("source")?.includes("plugin");

  // Landing surface: the dashboard for returning users. A brand-new workspace
  // is sent on to Copilot onboarding by the dashboard itself
  // (shouldAutoOpenOnboarding). An explicit ?redirect= still wins.
  let redirectUrl =
    (location.search &&
      Utils.getQueryParams(location.search).get("redirect")) ||
    "dashboard";

  useEffect(() => {
    setAdminTeamUser(userDetail.userInfo.team);
  }, [userDetail.userInfo.team]);

  useEffect(() => {
    if (userDetail.showUpgradeSettingsPopup) {
      userDetail.showUpgradeSettingsPopup = false;
      setTimeout(() => {
        if (location.pathname === "/settings/autoBcc") {
          Utils.showUpgradeSettingsPopup("autoBcc", true, false);
        } else if (location.pathname === "/settings/customUrl") {
          Utils.showUpgradeSettingsPopup(
            Utils.updateCustomUrlType(),
            true,
            false
          );
        } else if (location.pathname === "/settings/contacts") {
          Utils.showUpgradeSettingsPopup("customFields", true, false);
        }
      }, 50);
    } else if (userDetail.showUpgradePopup) {
      userDetail.showUpgradePopup = false;
      setTimeout(() => {
        location.pathname === "/tasks" &&
          Utils.showUpgradePopup("task", true, false);
      }, 50);
    }
  }, [location.pathname]);

  return (
    <Switch>
      <Route path="/templates" component={TemplateComponennt} />
      <Route path="/pluginSuccess" component={PluginSuccess} />
      {!adminTeamUser && subscriptionPlanId ? (
        ""
      ) : (
        <Route path="/pricing" component={PricingModule} />
      )}
      <Route path="/reports" component={ReportsModulev2} />
      <Route path="/reports-classic" component={ReportsModule} />
      <Route path="/calls" component={CallsModule} />
      <Route path="/contacts" component={ContactsComponent} />
      <Route path="/tasks" component={TaskRouting} />
      <Route path="/settings" component={SettingsComponent} />
      <Route path="/inbox" component={OutboxComponent} />
      <Route path="/sequences" component={SequencesRouting} />
      <Route path="/agents" component={AgentsRouting} />
      <Route path="/signals/tracked/:id" component={SignalTrackerRoute} />
      <Route path="/signals/competitors" component={CompetitorsRoute} />
      <Route path="/signals" component={SignalsRoute} />
      <Route path="/dashboard" component={DashboardModule} />
      <Route path="/discover" render={() => <Redirect to="/list-builder" />} />
      <Route path="/list-builder" component={DiscoverV2Module} />
      <Route path="/discover-v2" render={() => <Redirect to="/list-builder" />} />
      <Route path="/website-tracking" component={WebsiteTrackingModule} />
      <Route path="/data-toolkit" component={DataToolkitModule} />
      <Route path="/deep-research" component={DeepResearch} />
      {process.env.NODE_ENV === "development" && (
        <Route path="/copilot/fixtures" component={VisualFixtures} />
      )}
      <Route path="/copilot/:conversationId?" component={Copilot} />
      <Route path="/accounts" component={Accounts} />
      <Redirect
        from="/*"
        to={`${pluginUser ? "pluginSuccess" : `/${redirectUrl}`}`}
      />
    </Switch>
  );
});

export default DashboardRouting;
